import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductosCategorias } from '../_models/productos-categorias';

@Injectable({
  providedIn: 'root'
})
export class ProductosCategoriasService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosCategorias';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) {}

  /**
   * Obtiene las categorías de un producto por su ID.
   * @param idProducto ID del producto
   */
  listadoPorProducto(idProducto: string): Observable<ProductosCategorias[]> {
    return this.httClient.get(this.rutServicio + '/producto/' + idProducto)
      .pipe(map(res => res as ProductosCategorias[]));
  }

  /**
   * Crea un nuevo registro de categoría de producto.
   * @param reg Objeto ProductosCategorias a crear
   */
  crear(reg: ProductosCategorias): Observable<ProductosCategorias> {
    reg.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, reg)
      .pipe(map(res => res as ProductosCategorias));
  }

  /**
   * Actualiza un registro de categoría de producto.
   * @param reg Objeto ProductosCategorias a actualizar
   */
  actualizar(reg: ProductosCategorias): Observable<ProductosCategorias> {
    reg.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, reg)
      .pipe(map(res => res as ProductosCategorias));
  }

  /**
   * Guarda múltiples registros de categorías en una sola operación.
   * @param registros Lista de ProductosCategorias a guardar
   */
  bulk(registros: ProductosCategorias[]): Observable<ProductosCategorias[]> {
    registros.forEach(r => r.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httClient.post(this.rutServicio + '/bulk', registros)
      .pipe(map(res => res as ProductosCategorias[]));
  }
}
